
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiComandiDialog extends Serenity.EntityDialog<ApiComandiRow, any> {
        protected getFormKey() { return ApiComandiForm.formKey; }
        protected getIdProperty() { return ApiComandiRow.idProperty; }
        protected getLocalTextPrefix() { return ApiComandiRow.localTextPrefix; }
        protected getNameProperty() { return ApiComandiRow.nameProperty; }
        protected getService() { return ApiComandiService.baseUrl; }
        protected getDeletePermission() { return ApiComandiRow.deletePermission; }
        protected getInsertPermission() { return ApiComandiRow.insertPermission; }
        protected getUpdatePermission() { return ApiComandiRow.updatePermission; }

        protected form = new ApiComandiForm(this.idPrefix);

    }
}